<template>
    <div>
        <el-drawer title="批量编辑广告"  :visible="batchEditAds" direction="rtl" @close="close" wrapperClosable size="1250px" :append-to-body="true">
            <div class="drawerCon editAdsCon"  v-loading="loading">
                <el-form label-width="150px" style="margin-left:20px">
                    <el-form-item label="选择广告：">
                        <el-select v-model="id" @change="selectAd">
                            <el-option :label="ad.name+'#'+ad.id" :value="ad.id" v-for="ad in list" :key="ad.id">{{ad.name}}#{{ad.id}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <ads :accountId="accountId" :initData="initData" @setAds="setAds" :edit="true" :adsInfo="adsInfo"></ads>
            </div>
            <div class="demo-drawer__footer">
                <p></p>
                <div>
                    <el-button type="primary" @click="sure">保存</el-button>
                </div>
                <p></p>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import ads from '../../createAd/components/ads';
import {adForUpdate,updateAd,accountPixel} from '@/api/creatAd.js'
import {adConstsMap} from '@/api/creatAd.js'
import {mutateAds} from '@/api/adManagement.js'
    export default {
        props:['list','batchEditAds','initData'],
        data () {
            return {
                accountId:this.$store.getters.accountId,
                adsMsg:{},
                loading:false,
                draftCampaignId:null,
                adsInfo:null,
                type:'FB',
                id:null,
            }
        },
        components:{
            ads
        },
        methods: {
            close(){
                this.$emit('close','batchEditAds')
            },
            setAds(v){
                this.adsMsg = v;
            },
            selectAd(v){
                this.id = v;
                this.getAdInitData();
            },
            getAdInitData(){
                // console.log(this.id);
                let params = {
                    level:'ad',
                    type:this.type
                }
                params.accountId = this.accountId
                params.fbId = this.id;
                this.loading = true;
                adForUpdate(params).then(res=>{
                    this.loading = false;
                    this.draftCampaignId = res.data.draftCampaignId;
                    this.adsInfo = res.data.adcreative
                    this.adsInfo.promoteUrl = res.data.promoteUrl;
                    this.adsInfo.fbPixelId = res.data.fbPixelId;
                })
            },
            // 点击确定
            sure(){
                let info = JSON.parse(JSON.stringify(this.adsMsg[0]));
                // catalog 类型：提交前转换字段（与单个编辑 saveEditAds 逻辑一致）
                if (info.media_type === 'catalog' && info.templateData) {
                    const tplData = { ...info.templateData };
                    if (tplData.formatType === 'single') {
                        tplData.forceSingleLink = true;
                        tplData.multiShareEndCard = null;
                        tplData.formatOption = null;
                        info.catalogAssetFeedSpec = null;
                    } else if (tplData.formatType === 'collection') {
                        info.catalogAssetFeedSpec = {
                            ...(info.catalogAssetFeedSpec || {}),
                            optimization_type: 'FORMAT_AUTOMATION',
                            ad_formats: ['CAROUSEL', 'COLLECTION'],
                            bodies: null,
                            descriptions: null,
                        };
                        tplData.multiShareEndCard = true;
                        tplData.forceSingleLink = null;
                        tplData.formatOption = null;
                    } else if (tplData.formatType === 'carousel') {
                        tplData.multiShareEndCard = false;
                        tplData.forceSingleLink = null;
                        if (tplData.creativeOption === 'slideshow') {
                            tplData.formatOption = 'carousel_slideshows';
                        } else {
                            tplData.formatOption = 'carousel_images_multi_items';
                        }
                        // 轮播模式：构建多文案变体 bodies
                        const bodies = [];
                        if (tplData.message) {
                            bodies.push({ text: tplData.message });
                        }
                        if (tplData.messageVariants && tplData.messageVariants.length > 0) {
                            tplData.messageVariants.forEach((v) => {
                                if (v && v.trim()) {
                                    bodies.push({ text: v.trim() });
                                }
                            });
                        }
                        if (bodies.length > 1) {
                            const dofSpec = {
                                ...(info.catalogAssetFeedSpec || {}),
                                optimization_type: 'DEGREES_OF_FREEDOM',
                                bodies: bodies,
                            };
                            if (tplData.description && tplData.description.trim()) {
                                dofSpec.descriptions = [{ text: tplData.description.trim() }];
                            }
                            info.catalogAssetFeedSpec = dofSpec;
                        } else {
                            info.catalogAssetFeedSpec = {
                                ...(info.catalogAssetFeedSpec || {}),
                                optimization_type: 'FORMAT_AUTOMATION',
                                ad_formats: ['CAROUSEL', 'COLLECTION'],
                                bodies: null,
                                descriptions: null,
                            };
                        }
                    }
                    // 将 coverImages 转换为 childAttachments 格式
                    if (tplData.coverImages && tplData.coverImages.length > 0) {
                        const staticCards = tplData.coverImages.map(img => ({
                            link: tplData.link || '',
                            url: img.url,
                            source_id: img.sourceId || '',
                            image_hash: img.imageHash || '',
                            name: tplData.staticCardName || '',
                            description: tplData.staticCardDescription || '',
                            call_to_action_type: tplData.callToActionType || 'SHOP_NOW',
                            static_card: true,
                        }));
                        const existingDynamicCards = (tplData.childAttachments || []).filter(ca => !ca.static_card && !ca.staticCard);
                        tplData.childAttachments = [...staticCards, ...existingDynamicCards];
                    }
                    // 清理前端 UI 专用字段
                    delete tplData.formatType;
                    delete tplData.creativeOption;
                    delete tplData.coverImages;
                    delete tplData.messageVariants;
                    delete tplData.enableTextGeneration;
                    delete tplData.staticCardName;
                    delete tplData.staticCardDescription;
                    info.templateData = tplData;
                }
                let params = {accountId:this.accountId,adIds:this.list.map(v=>v.id),fbCreative:info}
                mutateAds(params).then(res=>{
                    if(res.code == 0){
                        this.$message({
                            type:'success',
                            message:'修改成功'
                        })
                        this.close();
                    }
                })
            }
        },
        watch:{
            list:{
                handler(){
                    // console.log(this.list[0]);
                    if(this.list.length){
                        this.id = this.list[0].id;
                    }
                },
                deep:true
            },
            batchEditAds(){
                if(this.batchEditAds){
                    this.getAdInitData();
                }
                
            }
        },
        mounted() {
            // this.getInitData();
            
        },
    }
</script>
<style lang="scss" scope>
    
</style>